import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const APP_TREE_CONTROLLER_SYMBOL = Symbol();
const useAppTreeController = ()=>useImmutableContext(APP_TREE_CONTROLLER_SYMBOL);
function useAppTreeControllerRef() {
    return useAppTreeController().getControllerRef();
}
function useAppTreeTreeRef() {
    return useAppTreeController().getTreeRef();
}
const AppTreeControllerProvider = ({ children })=>{
    const controllerRef = useRef(null);
    const treeRef = useRef(null);
    const refsRef = useRef({
        controllerRef,
        treeRef
    });
    refsRef.current = {
        controllerRef,
        treeRef
    };
    const [Provider, contextValue] = useImmutableContextProvider(APP_TREE_CONTROLLER_SYMBOL, {}, {}, {
        refActions: {
            getControllerRef: ()=>refsRef.current.controllerRef,
            getTreeRef: ()=>refsRef.current.treeRef
        }
    });
    return /*#__PURE__*/ _jsx(Provider, {
        value: contextValue,
        children: children
    });
};
export { AppTreeControllerProvider, useAppTreeControllerRef, useAppTreeTreeRef };
